import moment from "moment";
export var formatDate = {
    id: "formatDate",
    definition: function (value, noTime, noDate, noDay) {
        if (value) {
            var date = moment.utc(value).local();
            var pattern = void 0;
            if (noTime) {
                pattern = "DD.MM.YYYY";
            }
            else if (noDate) {
                pattern = "HH:mm:ss";
            }
            else if (noDay) {
                pattern = "MM.YYYY";
            }
            else {
                pattern = "DD.MM.YYYY HH:mm";
            }
            return date.format(pattern);
        }
    }
};
export var formatDatetime = {
    id: "formatDatetime",
    definition: function (value, pattern) {
        if (value) {
            var date = moment.utc(value).local();
            return date.format(pattern);
        }
    }
};
